import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "report-view" }
const _hoisted_2 = {
  class: "navbar navbar-expand-lg bg-dark text-white d-print-none",
  "data-bs-theme": "dark"
}
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_5 = { class: "navbar-nav me-auto" }
const _hoisted_6 = { class: "nav-item dropdown" }
const _hoisted_7 = {
  class: "nav-link dropdown-toggle fs-6 active",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = { class: "navbar-nav" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "resultado" }

import { reactive, onMounted } from "vue";

import "./relatorios.css"

export type IOrientacao = "Retrato" | "Paisagem";

interface IProps {
    titulo?: string,
    btnImprimir?: boolean,
    btnExcel?: boolean,
    btnLocalizar?: boolean,
    percZoom?: number,
    orientacao?: IOrientacao 
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    titulo: {},
    btnImprimir: { type: Boolean },
    btnExcel: { type: Boolean },
    btnLocalizar: { type: Boolean },
    percZoom: {},
    orientacao: {}
  },
  emits: ["onExcel", "onImprimir", "onZoom"],
  setup(__props: any, { emit: __emit }) {


var props = __props;

var emit = __emit;

var controle = reactive({
    exibeFiltros: false,
    percZoom: props.percZoom,
    orientacao: props.orientacao
})

onMounted(() => {
    if (controle.percZoom == undefined || controle.percZoom == 0 || controle.percZoom == null)
        controle.percZoom = 100;

    if (controle.orientacao == undefined || controle.orientacao  == null)
        controle.orientacao =  "Retrato";

})

const imprimir = () => {
    window.print();
};


const zoom = (percZoom: number) => {
    controle.percZoom = percZoom;
    emit("onZoom", controle.percZoom);
}

const localizar = () => {

    var el = document.getElementById("btnLocalizar") as HTMLLinkElement;
    const evt = new KeyboardEvent('keydown', { key: "F3", which: 114 });
    document.dispatchEvent(evt);

}

const alternarOrientacao = ()=>{
   controle.orientacao = (controle.orientacao == "Retrato" ? "Paisagem" : "Retrato");
}

const escaparCampoCsv = (valor: string): string => {
    return valor;
}

const exportarExcel = () => {
    emit("onExcel");

    const pagina = document.getElementById("pagina");
    if (!pagina) return;

    const tabelas = pagina.querySelectorAll("table");
    if (tabelas.length === 0) return;

    const linhas: string[] = [];
    tabelas.forEach(t => {
        t.querySelectorAll("tr").forEach(tr => {
            const celulas = [...tr.querySelectorAll("th,td")].map(c => escaparCampoCsv((c.textContent || "").trim()));
            linhas.push(celulas.join(";"));
        });
    });

    const bom = String.fromCharCode(0xFEFF);
    const conteudo = bom + linhas.join("\r\n");

    const blob = new Blob([conteudo], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${props.titulo || "relatorio"}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("a", _hoisted_7, [
                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fa fa-search" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_unref(controle).percZoom) + " % ", 1)
              ]),
              _createElementVNode("ul", _hoisted_8, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (zoom(25)))
                  }, "25 %")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (zoom(50)))
                  }, "50 %")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (zoom(75)))
                  }, "75 %")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (zoom(100)))
                  }, "100 %")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (zoom(125)))
                  }, "125 %")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (zoom(150)))
                  }, "150 %")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (zoom(200)))
                  }, "200 %")
                ])
              ])
            ])
          ]),
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", { class: "nav-item" }, [
              _createElementVNode("a", {
                class: "nav-link active",
                "aria-current": "page",
                href: "#",
                title: "Imprimir",
                onClick: imprimir
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "fa fa-print" }, null, -1)
              ]))])
            ]),
            _createElementVNode("li", { class: "nav-item" }, [
              _createElementVNode("a", {
                class: "nav-link active",
                href: "#",
                title: "Gerar CSV",
                onClick: exportarExcel
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "fa fa-file-excel" }, null, -1)
              ]))])
            ]),
            _createElementVNode("li", { class: "nav-item" }, [
              _createElementVNode("a", {
                class: "nav-link active",
                href: "#",
                title: "Localizar",
                onClick: localizar,
                id: "btnLocalizar"
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "fa fa-binoculars" }, null, -1)
              ]))])
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("a", {
                class: "nav-link active",
                href: "#",
                title: "Alternar Retrato/Paisagem",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (alternarOrientacao())),
                id: "btnOrientacao"
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa", _unref(controle).orientacao == 'Retrato' ? 'fa-arrows-alt-v' : 'fa-arrows-alt-h'])
                }, null, 2)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        class: _normalizeClass(["pagina", _unref(controle).orientacao == 'Retrato' ? 'retrato' : 'paisagem']),
        id: "pagina"
      }, [
        _renderSlot(_ctx.$slots, "default", {
          style: _normalizeStyle('zoom:' + _unref(controle).percZoom + '%')
        })
      ], 2)
    ])
  ]))
}
}

})